module.exports = __webpack_public_path__ + "img/product_3.64f3d6f.jpg";